import { Lightbulb } from 'lucide-react'

const NBVRecommendations = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <Lightbulb className="h-6 w-6 text-yellow-600" />
        <h2 className="text-2xl font-bold text-gray-900">💡 Rekomendacje NBV</h2>
      </div>
      
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <Lightbulb className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Rekomendacje NBV
        </h3>
        <p className="text-gray-600">
          Komponent w trakcie implementacji. Będzie zawierał analizy i rekomendacje NBV.
        </p>
      </div>
    </div>
  )
}

export default NBVRecommendations